import script from "./AbsentStudentsSubpage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AbsentStudentsSubpage.vue?vue&type=script&lang=ts&setup=true"

import "./AbsentStudentsSubpage.vue?vue&type=style&index=0&id=af21dac0&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af21dac0"]])

export default __exports__